import { useAuth } from "@/modules/auth/store"
import { useCosmos } from "@/modules/cosmos/stores/use-cosmos-store"
import mixpanelClient from "@/services/mixpanel"
import { useEffect } from "react"
import { Outlet, useLocation } from "react-router-dom"

export default function Body(): React.ReactElement {
  const { user } = useAuth()
  const { cosmosKey } = useCosmos()
  const { pathname } = useLocation()

  useEffect(() => {
    if (!user.id) return
    mixpanelClient.global.trackAuthenticatedUsers({
      fullname: `${user.firstName} ${user.lastName}`,
      email: user.emailAddress,
      organization: cosmosKey,
    })
  }, [user.id, pathname])

  return (
    <div className="flex h-full w-full">
      <Outlet />
    </div>
  )
}
